import React from "react";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const TestimonialsData = [
  {
    id: 1,
    name: "Partik Pandya",
    text: "Shree Dattguru Enterprise has been an excellent partner for our Sun Pharma projects. They delivered exceptional services, including Anganwadi construction, school building, and plumbing work.",
    img: "https://picsum.photos/101/101",
    delay: 0.2,
    description:'Sun Pharma'
  },
  {
    id: 2,
    name: "Mitesh Surti",
    text: "Their attention to detail, professionalism, and commitment to quality made a significant impact. Highly recommend them for any infrastructure or construction needs!",
    img: "https://picsum.photos/102/102",
    delay: 0.5,
    description:'Rubamin'
  },
  {
    id: 3,
    name: "Ronak Gosai",
    text: "Shree DattGuru Enterprise team's efficiency and dedication ensured high-quality results. We highly recommend their expertise for any construction and infrastructure projects.",
    img: "https://picsum.photos/104/104",
    delay: 0.8,
    description:'JCB'

  },
  {
    id: 4,
    name: "Himanshu trivedi",
    text: "From start to finish, their team showed incredible professionalism and attention to detail. They transformed our home with quality craftsmanship, completing the project on time and within budget.",
    img: "https://picsum.photos/103/103",
    delay: 1.1,
    description:''
  },
  {
    id: 5,
    name: "Yagenesh kher",
    text: "They helping us build the school wall, create a children’s development garden, and set up the electricity. Their team worked diligently, ensuring everything was done to the highest standards. ",
    img: "https://picsum.photos/105/105",
    delay: 1.1,
    description:''
  },
  {
    id: 6,
    name: "Ronak Suthar",
    text: "They play crucial role in helping us build complete female toilets across five different districts in Gujarat. Their team demonstrated exceptional dedication, efficiency, and attention to detail in every project. ",
    img: "https://picsum.photos/106/106",
    delay: 1.1,
    description:'Be the change'
  },
  {
    id: 7,
    name: "Ashish Kumar Behuray",
    text: "A key partner in helping us construct an RCC road, complete the paint work of our building, and create an educational garden.Bharat Bhai team provided high-quality workmanship, ensuring everything was completed on time and to the highest standards.",
    img: "https://picsum.photos/107/107",
    delay: 1.1,
    description:''
  },
  {
    id: 8,
    name: "Kalpesh Shah",
    text: "Shree Dattguru Enterprise provided excellent services for Podar Wonder School, handling painting, plumbing, and common school kitchen work. ",
    img: "https://picsum.photos/103/103",
    delay: 1.1,
    description:'Podar Wonder School'
  },
  {
    id: 9,
    name: "Nikul Davda",
    text: "They provided exceptional services for United Way of Bardoa, including the construction of three different toilets in villages, RO machine installation, and more.",
    img: "https://picsum.photos/109/109",
    delay: 1.1,
    description:'United Way of Baroda'
  },
];

const Review = () => {
  const setting = {
    dots: true,
    arrow: false,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    cssEase: "linear",
    pauseOnHover: true,
    pauseOnFocus: true,
    responsive: [
      {
        breakpoint: 10000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
          infinite: true,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };
  return (
    <div className="py-14 mb-10">
      <div className="container">
          <Slider {...setting}>
            {TestimonialsData.map((item) => {
              return (
                <div key={item.id}>
                  <div className="flex flex-col gap-4 p-8 shadow-lg mx-4 rounded-xl bg-[#F2F0F0] min-h-[353px]">
                    {/* upper section */}
                    <div className="flex justify-start items-center gap-5">
                      <img
                        src={item.img}
                        alt=""
                        className="w-16 h-16 rounded-full"
                      />
                      <div>
                        <p className="text-xl font-bold text-black/80 ">
                          {item.name}
                        </p>
                        <p className="fontText">{item.description}</p>
                      </div>
                    </div>
                    {/* bottom section */}
                    <div className="py-6 space-y-4">
                      <p className="text-sm text-gray-500 fontText">{item.text}</p>
                      <p>⭐⭐⭐⭐⭐</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </Slider>
      </div>
    </div>
  );
};

export default Review;